import { render, staticRenderFns } from "./BeschreibungDraftEditor.vue?vue&type=template&id=05067f7c&scoped=true&"
import script from "./BeschreibungDraftEditor.vue?vue&type=script&lang=ts&"
export * from "./BeschreibungDraftEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BeschreibungDraftEditor.vue?vue&type=style&index=0&id=05067f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05067f7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VIcon,VRow,VSpacer,VTextField})
